import React, { useMemo } from 'react';
import { Receipt } from 'lucide-react';
import { formatCurrency } from '../Utils/format';
import { getMaxParcelas } from '../Utils/cardBrand';
import { getPrimeiroVencimento } from '../Utils/boletoConfig';
import { BoletoFieldsProps } from '../Types';

export const BoletoFields: React.FC<BoletoFieldsProps> = ({
  method,
  finalValue,
  values,
  errors,
  onChange,
}) => {
  const maxParcelas = useMemo(() => getMaxParcelas(method), [method]);
  const primeiroVencimento = useMemo(() => getPrimeiroVencimento(method), [method]);
  const installmentOptions = useMemo(
    () => Array.from({ length: maxParcelas }, (_, i) => i + 1),
    [maxParcelas]
  );

  const vencimentoLabel = primeiroVencimento
    ? primeiroVencimento.split('-').reverse().join('/')
    : 'Não configurado';

  return (
    <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 backdrop-blur-sm">
      <div className="flex items-center gap-3 mb-4 pb-3 border-b border-gray-100">
        <div className="w-8 h-8 bg-gradient-to-br from-amber-500 to-orange-600 rounded-lg flex items-center justify-center">
          <Receipt className="w-4 h-4 text-white" />
        </div>
        <h3 className="text-xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
          Configurações do Boleto
        </h3>
      </div>

      <div className="space-y-4">
        <div>
          <label className="text-sm font-medium text-gray-600">Primeiro vencimento</label>
          <p
            className={`mt-1 text-base font-semibold ${
              primeiroVencimento ? 'text-gray-800' : 'text-red-600'
            }`}
          >
            {vencimentoLabel}
          </p>
          {!primeiroVencimento && (
            <p className="text-red-500 text-sm mt-1">
              {errors.boletoConfig || 'Configure o primeiro vencimento no cadastro do link.'}
            </p>
          )}
        </div>

        <div>
          <label className="text-sm font-medium text-gray-600 flex items-center gap-1">
            Número de Parcelas <span className="text-red-500">*</span>
          </label>
          <select
            value={values.installments}
            onChange={(e) => onChange('installments', parseInt(e.target.value, 10))}
            className={`w-full px-4 mt-1 py-2 h-[42px] rounded-lg border bg-white ${
              errors.installments ? 'border-red-500' : 'border-gray-300'
            } focus:outline-none focus:ring-1 focus:ring-blue-300`}
          >
            {installmentOptions.map((n) => (
              <option key={n} value={n}>
                {n}x de {formatCurrency(finalValue / n)}
                {n === 1 ? ' (à vista)' : ''}
              </option>
            ))}
          </select>
          {errors.installments && (
            <p className="text-red-500 text-sm mt-1">{errors.installments}</p>
          )}
        </div>
      </div>
    </div>
  );
};
